var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.8c2.8 0 5.4-.8 7.6-2.4l8 8c.8.8 2 .8 2.8 0s.8-2 0-2.8l-8-8c3.6-5 3.2-12.2-1.2-16.8C19.6 1.4 16.4 0 13 0S6.2 1.4 3.8 3.8 0 9.4 0 13s1.4 6.6 3.8 9 5.6 3.8 9.2 3.8M6.6 6.6C8.2 5 10.6 4 13 4s4.6 1 6.2 2.6c3.4 3.4 3.4 9.2 0 12.6s-9.2 3.4-12.6 0C5 17.6 4 15.2 4 13c0-2.4 1-4.8 2.6-6.4"
  })));
};
export default SvgSearch;